import React, { useEffect, useMemo, useRef, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { setAllAssessments } from '../../../Reducers/allAssessmentsReducer'

import { Link } from 'react-router-dom'

import { getAllCoursesByRole, getAssestmentsByRole, getUsersCourses, getCourseById, exportCourseAssessmentsDetails } from '../../../Constants/Api/functions/function'

import { Button, Input, Select, Space, Spin, Table, Tag, Card, Segmented, Empty, Tooltip, Progress, message } from 'antd'
import {
    PlusOutlined,
    SearchOutlined,
    TrophyOutlined,
    BookOutlined,
    AppstoreOutlined,
    BarsOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    FileTextOutlined,
    LockOutlined,
    CalendarOutlined,
    EyeOutlined,
    UploadOutlined,
    FileExcelOutlined
} from '@ant-design/icons'
import Highlighter from 'react-highlight-words'
import dayjs from 'dayjs'

// API
import { setAllCources } from '../../../Reducers/allCourcesReducer'
import {
    getGradeDetails,
    calculateCoursePerformance,
    calculateCourseAssessmentBreakdown,
    getAssessmentTypeDetails
} from '../../../Utils/gradeUtils'

import './style.scss'

import AddAssessment from './AddAssessment'
import AcademicTranscriptModal from './AcademicTranscriptModal'

const Assessments = () => {
    const [loading, setLoading] = useState(false)
    const [openAddAssessment, setOpenAddAssessment] = useState(false)
    const allCources = useSelector(state => state.allCources.allCources)
    const [assessments, setAssessments] = useState()
    const dispatch = useDispatch()
    const userProfile = useSelector(state => state.userProfile.userProfile)
    const allAssessments = useSelector(state => state.allAssessments.allAssessments)
    const [tableData, setTableData] = useState([])
    const [extraCourseMap, setExtraCourseMap] = useState({})
    const [searchText, setSearchText] = useState('')
    const [searchedColumn, setSearchedColumn] = useState('')
    const searchInput = useRef(null)

    const [selectedCourseFilter, setSelectedCourseFilter] = useState('all')
    const [searchAssessmentQuery, setSearchAssessmentQuery] = useState('')

    const isStudent = userProfile?.role === 'student'
    const [viewMode, setViewMode] = useState('grouped')
    const [selectedTranscriptGroup, setSelectedTranscriptGroup] = useState(null)
    const [isTranscriptOpen, setIsTranscriptOpen] = useState(false)
    const [exportingCourseId, setExportingCourseId] = useState(null)

    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth <= 768
        }
        return false
    })

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        if (userProfile?.role && userProfile?.id) {
            hadleGetCources()
            handleGetAssessments()
        }
    }, [userProfile?.role, userProfile?.id])

    useEffect(() => {
        if (assessments && assessments.length) {
            setTableData(
                assessments.map((assessment) => {
                    const course = allCources?.find((c) => String(c?.id) === String(assessment.courseId)) || extraCourseMap[String(assessment.courseId)]
                    const courseName = assessment?.courseName || course?.name || 'Course'
                    return {
                        id: assessment?.id,
                        key: assessment?.id,
                        title: assessment?.name,
                        assessmentType: assessment?.assessmentType || 'CA',
                        course: courseName,
                        courseId: assessment?.courseId,
                        endDate: assessment?.endDate,
                        status: assessment?.attempt?.id ? true : false,
                        marks: assessment?.attempt?.marks,
                        totalSubmissions: Number(assessment?.totalSubmissions) || 0,
                        uniqueSubmissions: Number(assessment?.uniqueSubmissions) || 0,
                        enrolledStudents: Number(assessment?.enrolledStudents) || 0,
                        rawAssessment: assessment,
                    }
                })
            )
        } else {
            setTableData([])
        }
    }, [assessments, allCources])

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText(selectedKeys[0])
        setSearchedColumn(dataIndex)
    }

    const handleReset = (clearFilters) => {
        clearFilters()
        setSearchText('')
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            })
                            setSearchText(selectedKeys[0])
                            setSearchedColumn(dataIndex)
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close()
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100)
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    })

    const renderDueDate = (endDate) => {
        if (!endDate) return <span style={{ color: '#94a3b8' }}>N/A</span>
        const now = new Date()
        const end = new Date(endDate)
        const diff = end - now
        const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
        let color = '#334155'
        if (diffDays <= 7 && diffDays >= 0) {
            color = '#2563eb'
        } else if (diffDays < 0) {
            color = '#dc2626'
        }
        return (
            <span style={{ color, fontWeight: diffDays < 0 ? 600 : 500 }}>
                {endDate}
            </span>
        )
    }

    const renderMobileAssessmentCard = (item, sectionType) => {
        const isCa = sectionType === 'CA' || item.assessmentType !== 'FINAL_EXAM'
        const isFinal = sectionType === 'FINAL_EXAM' || item.assessmentType === 'FINAL_EXAM'
        const totalSubs = Number(item.totalSubmissions) || 0
        const enrolled = Number(item.enrolledStudents) || 0
        const pct = enrolled > 0 ? Math.round((totalSubs / enrolled) * 100) : 0

        return (
            <div
                key={item.id}
                className={`mobile-assessment-card ${isFinal ? 'final-exam-card' : 'ca-card'}`}
            >
                <div className="mobile-card-header">
                    <div className="mobile-card-title-wrap">
                        <h4 className="mobile-card-title">
                            <Link to={`/dashboard/assessments/${item.id}`}>
                                {item.title}
                            </Link>
                        </h4>
                        <Space size={6} wrap style={{ marginTop: 4 }}>
                            <Tag color={isFinal ? 'purple' : 'blue'} style={{ fontSize: 11, fontWeight: 600, margin: 0, borderRadius: 4 }}>
                                {isFinal ? 'Final Exam (50%)' : 'Continuous Assessment (50%)'}
                            </Tag>
                            {sectionType === 'FLAT' && (item.course || item.courseName) && (
                                <Tag color="geekblue" style={{ fontSize: 11, margin: 0, borderRadius: 4 }}>
                                    {item.course || item.courseName}
                                </Tag>
                            )}
                        </Space>
                    </div>

                    <div className="mobile-card-badge">
                        {isStudent ? (
                            item.status ? (
                                <Tag color="success" icon={<CheckCircleOutlined />} style={{ margin: 0, fontWeight: 600, borderRadius: 6 }}>
                                    Attempted
                                </Tag>
                            ) : isFinal && !item.isEligibleForFinalExam ? (
                                <Tag color="error" icon={<LockOutlined />} style={{ margin: 0, fontWeight: 600, borderRadius: 6 }}>
                                    Locked
                                </Tag>
                            ) : (
                                <Tag color="default" style={{ margin: 0, fontWeight: 600, borderRadius: 6 }}>
                                    Not Attempted
                                </Tag>
                            )
                        ) : (
                            <Tag
                                color={pct >= 100 ? 'success' : pct > 0 ? 'processing' : 'default'}
                                style={{ margin: 0, fontWeight: 600, fontSize: 12, borderRadius: 6 }}
                            >
                                {pct}% Done
                            </Tag>
                        )}
                    </div>
                </div>

                <div className="mobile-card-body">
                    <div className="mobile-card-row">
                        <span className="row-label">
                            <CalendarOutlined style={{ marginRight: 6, color: '#64748b' }} />
                            Due Date:
                        </span>
                        <span className="row-value">{renderDueDate(item.endDate)}</span>
                    </div>

                    {isStudent ? (
                        <>
                            {isCa ? (
                                <div className="mobile-card-row">
                                    <span className="row-label">Marks & Result:</span>
                                    <span className="row-value">
                                        {item.marks !== null && item.marks !== undefined && item.marks !== '' && !isNaN(Number(item.marks)) ? (
                                            <Space size={6} wrap>
                                                <strong style={{ color: '#0284c7', fontSize: 14 }}>{Number(item.marks)}%</strong>
                                                <Tag color={getGradeDetails(item.marks).tagColor} style={{ fontWeight: 600, margin: 0, borderRadius: 4 }}>
                                                    Grade {getGradeDetails(item.marks).grade} • {getGradeDetails(item.marks).classification}
                                                </Tag>
                                            </Space>
                                        ) : (
                                            <span style={{ color: '#94a3b8' }}>{item.status ? 'Pending Evaluation' : 'Not Attempted'}</span>
                                        )}
                                    </span>
                                </div>
                            ) : (
                                <div className="mobile-card-row">
                                    <span className="row-label">Final Evaluation:</span>
                                    <span className="row-value">
                                        {isFinal && !item.isEligibleForFinalExam && !item.status ? (
                                            <span style={{ color: '#ef4444', fontWeight: 500, fontSize: 12 }}>
                                                Locked (Requires CA Average ≥ 50%)
                                            </span>
                                        ) : item.marks !== null && item.marks !== undefined && item.marks !== '' ? (
                                            <Tag color={getGradeDetails(item.marks).tagColor} style={{ fontWeight: 600, margin: 0, borderRadius: 4 }}>
                                                Grade {getGradeDetails(item.marks).grade} • {getGradeDetails(item.marks).classification}
                                            </Tag>
                                        ) : (
                                            <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                                                {item.status ? 'Pending Evaluation' : 'Ungraded'}
                                            </span>
                                        )}
                                    </span>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="mobile-submissions-box">
                            <div className="submissions-box-header">
                                <span className="box-title">Student Submissions</span>
                                <span className="box-count">
                                    <strong>{totalSubs}</strong> / {enrolled} Enrolled
                                </span>
                            </div>
                            <Progress
                                percent={Math.min(pct, 100)}
                                showInfo={false}
                                size="small"
                                strokeColor={pct >= 80 ? '#10b981' : pct >= 40 ? '#3b82f6' : '#f59e0b'}
                                trailColor="#e2e8f0"
                                style={{ margin: '6px 0 0 0' }}
                            />
                        </div>
                    )}
                </div>

                <div className="mobile-card-footer">
                    {isStudent ? (
                        item.status ? (
                            <Link to={`/dashboard/assessments/${item.id}`} style={{ width: '100%', display: 'block' }}>
                                <Button block icon={<EyeOutlined />} style={{ fontWeight: 600, height: 38, borderRadius: 8 }}>
                                    View My Submission
                                </Button>
                            </Link>
                        ) : isFinal && !item.isEligibleForFinalExam ? (
                            <Tooltip title={item.caEligibilityReason || 'Requires Continuous Assessment Average ≥ 50%'}>
                                <Button
                                    block
                                    disabled
                                    danger={item.caEligibilityStatus === 'NOT_ELIGIBLE'}
                                    style={{ fontWeight: 600, height: 38, borderRadius: 8 }}
                                >
                                    <LockOutlined /> {item.caEligibilityStatus === 'NOT_ELIGIBLE' ? 'Ineligible for Final Exam' : 'Final Exam Locked (CA < 50%)'}
                                </Button>
                            </Tooltip>
                        ) : isFinal ? (
                            <Link to={`/dashboard/assessments/${item.id}`} style={{ width: '100%', display: 'block' }}>
                                <Button
                                    block
                                    type="primary"
                                    icon={<UploadOutlined />}
                                    style={{ fontWeight: 600, height: 38, borderRadius: 8, background: '#8b5cf6', borderColor: '#8b5cf6' }}
                                >
                                    Submit Final Exam →
                                </Button>
                            </Link>
                        ) : (
                            <Link to={`/dashboard/assessments/${item.id}`} style={{ width: '100%', display: 'block' }}>
                                <Button block type="primary" icon={<UploadOutlined />} style={{ fontWeight: 600, height: 38, borderRadius: 8 }}>
                                    Submit Assessment →
                                </Button>
                            </Link>
                        )
                    ) : (
                        <div style={{ display: 'flex', gap: 8, width: '100%' }}>
                            <Link to={`/dashboard/assessments/${item.id}`} style={{ flex: 1 }}>
                                <Button block type="primary" icon={<FileTextOutlined />} style={{ fontWeight: 600, height: 38, borderRadius: 8 }}>
                                    View Submissions ({totalSubs}) →
                                </Button>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    // Course groups calculated from current assessments and allCources
    const courseGroups = useMemo(() => {
        if (!assessments || assessments.length === 0) return []

        const groupsMap = {}
        assessments.forEach((assessment) => {
            const cId = assessment?.courseId || 'unassigned'
            if (!groupsMap[cId]) {
                const course = allCources?.find((c) => String(c?.id) === String(assessment.courseId)) || extraCourseMap[String(assessment.courseId)]
                const courseName = assessment?.courseName || course?.name || 'Course'
                const courseCode = assessment?.courseCode || course?.courseid || ''
                const courseStatus = assessment?.courseStatus || course?.status || 'ongoing'
                groupsMap[cId] = {
                    courseId: cId,
                    courseName,
                    courseCode,
                    courseStatus,
                    courseObj: course,
                    assessments: [],
                }
            }
            groupsMap[cId].assessments.push({
                ...assessment,
                courseName: assessment?.courseName || groupsMap[cId].courseName,
                courseCode: assessment?.courseCode || groupsMap[cId].courseCode,
            })
        })

        return Object.values(groupsMap).map((group) => {
            const performance = calculateCoursePerformance(group.assessments)
            const breakdown = calculateCourseAssessmentBreakdown(group.assessments)
            return {
                ...group,
                performance,
                breakdown,
            }
        })
    }, [assessments, allCources, extraCourseMap])

    // Columns for Admin / Instructor flat table view
    const adminColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '10%',
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/dashboard/assessments/${record.id}`}>
                        View
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Type',
            dataIndex: 'assessmentType',
            key: 'assessmentType',
            width: '12%',
            render: (type) => {
                const info = getAssessmentTypeDetails(type)
                return (
                    <Tag color={info.tagColor} style={{ fontWeight: 600 }}>
                        {info.shortLabel}
                    </Tag>
                )
            }
        },
        {
            title: 'Assessment Title',
            dataIndex: 'title',
            key: 'title',
            width: '28%',
            ...getColumnSearchProps('title'),
        },
        {
            title: 'Course',
            dataIndex: 'course',
            key: 'course',
            width: '20%',
            ...getColumnSearchProps('course'),
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '16%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
        },
        {
            title: 'Submissions',
            dataIndex: 'totalSubmissions',
            key: 'totalSubmissions',
            width: '18%',
            sorter: (a, b) => (Number(a.totalSubmissions) || 0) - (Number(b.totalSubmissions) || 0),
            render: (val, record) => {
                const totalSubs = Number(record.totalSubmissions) || 0;
                const enrolled = Number(record.enrolledStudents) || 0;
                const pct = enrolled > 0 ? Math.round((totalSubs / enrolled) * 100) : 0;
                return (
                    <div style={{ minWidth: 120 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                            <Link to={`/dashboard/assessments/${record.id}`}>
                                <span style={{ fontWeight: 700, color: '#0f172a', fontSize: 13 }}>
                                    {totalSubs}{' '}
                                    <span style={{ color: '#64748b', fontWeight: 500, fontSize: 12 }}>
                                        / {enrolled} Enrolled
                                    </span>
                                </span>
                            </Link>
                            <Tag color={pct >= 100 ? 'success' : pct > 0 ? 'processing' : 'default'} style={{ margin: 0, fontSize: 11, padding: '0 5px', borderRadius: 8 }}>
                                {pct}%
                            </Tag>
                        </div>
                        <Progress
                            percent={Math.min(pct, 100)}
                            showInfo={false}
                            size="small"
                            strokeColor={pct >= 80 ? '#16a34a' : pct >= 40 ? '#2563eb' : '#f59e0b'}
                            trailColor="#f1f5f9"
                            style={{ margin: 0 }}
                        />
                    </div>
                );
            }
        },
    ]

    // Columns for Student flat table view (strictly NO numeric marks)
    const studentFlatColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '10%',
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/dashboard/assessments/${record.id}`}>
                        View
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Type',
            dataIndex: 'assessmentType',
            key: 'assessmentType',
            width: '10%',
            render: (type) => {
                const info = getAssessmentTypeDetails(type)
                return (
                    <Tag color={info.tagColor} style={{ fontWeight: 600 }}>
                        {info.shortLabel}
                    </Tag>
                )
            }
        },
        {
            title: 'Assessment Title',
            dataIndex: 'title',
            key: 'title',
            width: '22%',
            ...getColumnSearchProps('title'),
        },
        {
            title: 'Course',
            dataIndex: 'course',
            key: 'course',
            width: '18%',
            ...getColumnSearchProps('course'),
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '14%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
            render: (endDate) => {
                const now = new Date()
                const end = new Date(endDate)
                const diff = end - now
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
                let color = 'black'
                if (diffDays <= 7 && diffDays >= 0) {
                    color = '#1890ff'
                } else if (diffDays < 0) {
                    color = '#f5222d'
                }
                return (
                    <span style={{ color: color }}>
                        {endDate}
                    </span>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '12%',
            render: (status) => {
                return status ? (
                    <Tag color="success">Attempted</Tag>
                ) : (
                    <Tag color="error">Not Attempted</Tag>
                )
            }
        },
        {
            title: 'Grade',
            dataIndex: 'marks',
            key: 'grade',
            width: '14%',
            render: (marks, record) => {
                if (marks === null || marks === undefined || marks === '') {
                    return (
                        <span style={{ color: '#8c8c8c' }}>
                            {record.status ? 'Pending' : 'N/A'}
                        </span>
                    )
                }
                const gradeInfo = getGradeDetails(marks)
                return (
                    <Tag color={gradeInfo.tagColor} style={{ fontWeight: '600' }}>
                        Grade {gradeInfo.grade} • {gradeInfo.classification}
                    </Tag>
                )
            }
        }
    ]

    // Columns inside Continuous Assessments (CA) table for Students (shows Marks & Grade)
    const studentCAColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '14%',
            render: (text, record) => {
                if (record.status) {
                    return (
                        <Link to={`/dashboard/assessments/${record.id}`}>
                            <Button type="link" size="small" style={{ padding: 0 }}>
                                View Submission
                            </Button>
                        </Link>
                    )
                }
                return (
                    <Link to={`/dashboard/assessments/${record.id}`}>
                        <Button type="link" size="small" style={{ padding: 0, fontWeight: 600 }}>
                            Submit Task
                        </Button>
                    </Link>
                )
            },
        },
        {
            title: 'Continuous Assessment Task',
            dataIndex: 'title',
            key: 'title',
            width: '38%',
            ...getColumnSearchProps('title'),
            render: (title) => <span style={{ fontWeight: 600, color: '#0f172a' }}>{title}</span>
        },
        {
            title: 'Due Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '16%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
            render: (endDate) => {
                if (!endDate) return <span style={{ color: '#94a3b8' }}>N/A</span>
                const now = new Date()
                const end = new Date(endDate)
                const diff = end - now
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
                let color = '#334155'
                if (diffDays <= 7 && diffDays >= 0) {
                    color = '#2563eb'
                } else if (diffDays < 0) {
                    color = '#dc2626'
                }
                return (
                    <span style={{ color: color, fontWeight: diffDays < 0 ? 500 : 400 }}>
                        {endDate}
                    </span>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '12%',
            render: (status) => status ? (
                <Tag color="success">Attempted</Tag>
            ) : (
                <Tag color="default">Not Attempted</Tag>
            )
        },
        {
            title: 'Marks (%)',
            dataIndex: 'marks',
            key: 'marks',
            width: '10%',
            align: 'right',
            render: (marks, record) => {
                if (marks !== null && marks !== undefined && marks !== '' && !isNaN(Number(marks))) {
                    return <strong style={{ color: '#0284c7', fontSize: 14 }}>{Number(marks)}%</strong>
                }
                return <span style={{ color: '#94a3b8' }}>{record.status ? 'Pending' : '-'}</span>
            }
        },
        {
            title: 'Grade Awarded',
            dataIndex: 'marks',
            key: 'grade',
            width: '18%',
            render: (marks, record) => {
                if (marks === null || marks === undefined || marks === '') {
                    return (
                        <span style={{ color: '#8c8c8c', fontSize: 13 }}>
                            {record.status ? 'Pending Evaluation' : 'Ungraded'}
                        </span>
                    )
                }
                const gradeInfo = getGradeDetails(marks)
                return (
                    <Tag color={gradeInfo.tagColor} style={{ fontWeight: '600' }}>
                        Grade {gradeInfo.grade} • {gradeInfo.classification}
                    </Tag>
                )
            }
        }
    ]

    // Columns inside Final Examination table for Students (strictly NO numeric marks)
    const studentFinalExamColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '16%',
            render: (text, record) => {
                if (record.status) {
                    return (
                        <Link to={`/dashboard/assessments/${record.id}`}>
                            <Button type="link" size="small" style={{ padding: 0 }}>
                                View Submission
                            </Button>
                        </Link>
                    )
                }

                if (!record.isEligibleForFinalExam) {
                    if (record.caEligibilityStatus === 'NOT_ELIGIBLE') {
                        return (
                            <Tooltip title={record.caEligibilityReason || 'Ineligible for Final Exam (CA average < 50%)'}>
                                <Button size="small" disabled danger style={{ padding: '0 8px', borderRadius: 4 }}>
                                    <LockOutlined /> Ineligible
                                </Button>
                            </Tooltip>
                        )
                    }
                    return (
                        <Tooltip title={record.caEligibilityReason || 'Awaiting evaluation of all Continuous Assessments'}>
                            <Button size="small" disabled style={{ padding: '0 8px', borderRadius: 4 }}>
                                <LockOutlined /> Locked
                            </Button>
                        </Tooltip>
                    )
                }

                return (
                    <Link to={`/dashboard/assessments/${record.id}`}>
                        <Button type="primary" size="small" style={{ padding: '0 10px', borderRadius: 4 }}>
                            Submit Final Exam
                        </Button>
                    </Link>
                )
            },
        },
        {
            title: 'Final Examination Component',
            dataIndex: 'title',
            key: 'title',
            width: '46%',
            ...getColumnSearchProps('title'),
            render: (title) => <span style={{ fontWeight: 600, color: '#0f172a' }}>{title}</span>
        },
        {
            title: 'Due Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '18%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
            render: (endDate) => {
                if (!endDate) return <span style={{ color: '#94a3b8' }}>N/A</span>
                const now = new Date()
                const end = new Date(endDate)
                const diff = end - now
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
                let color = '#334155'
                if (diffDays <= 7 && diffDays >= 0) {
                    color = '#2563eb'
                } else if (diffDays < 0) {
                    color = '#dc2626'
                }
                return (
                    <span style={{ color: color, fontWeight: diffDays < 0 ? 500 : 400 }}>
                        {endDate}
                    </span>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '12%',
            render: (status, record) => {
                if (status) {
                    return <Tag color="success">Attempted</Tag>
                }
                if (!record.isEligibleForFinalExam) {
                    return <Tag color="error">Ineligible</Tag>
                }
                return <Tag color="default">Not Attempted</Tag>
            }
        },
        {
            title: 'Grade Awarded',
            dataIndex: 'marks',
            key: 'grade',
            width: '18%',
            render: (marks, record) => {
                if (!record.isEligibleForFinalExam && !record.status) {
                    return <span style={{ color: '#ef4444', fontWeight: 500 }}>Ineligible</span>
                }
                if (marks === null || marks === undefined || marks === '') {
                    return (
                        <span style={{ color: '#8c8c8c', fontSize: 13 }}>
                            {record.status ? 'Pending Evaluation' : 'Ungraded'}
                        </span>
                    )
                }
                const gradeInfo = getGradeDetails(marks)
                return (
                    <Tag color={gradeInfo.tagColor} style={{ fontWeight: '600' }}>
                        Grade {gradeInfo.grade} • {gradeInfo.classification}
                    </Tag>
                )
            }
        }
    ]

    // Admin Columns for Continuous Assessments (CA)
    const adminCAColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '14%',
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/dashboard/assessments/${record.id}`}>
                        <Button type="link" size="small" style={{ padding: 0, fontWeight: 600 }}>
                            View Task
                        </Button>
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Continuous Assessment Task',
            dataIndex: 'title',
            key: 'title',
            width: '44%',
            ...getColumnSearchProps('title'),
            render: (title) => <span style={{ fontWeight: 600, color: '#0f172a' }}>{title}</span>
        },
        {
            title: 'Due Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '20%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
            render: (endDate) => {
                if (!endDate) return <span style={{ color: '#94a3b8' }}>N/A</span>
                const now = new Date()
                const end = new Date(endDate)
                const diff = end - now
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
                let color = '#334155'
                if (diffDays <= 7 && diffDays >= 0) {
                    color = '#2563eb'
                } else if (diffDays < 0) {
                    color = '#dc2626'
                }
                return (
                    <span style={{ color: color, fontWeight: diffDays < 0 ? 500 : 400 }}>
                        {endDate}
                    </span>
                )
            }
        },
        {
            title: 'Submissions',
            dataIndex: 'totalSubmissions',
            key: 'totalSubmissions',
            width: '24%',
            sorter: (a, b) => (Number(a.totalSubmissions) || 0) - (Number(b.totalSubmissions) || 0),
            render: (val, record) => {
                const totalSubs = Number(record.totalSubmissions) || 0;
                const enrolled = Number(record.enrolledStudents) || 0;
                const pct = enrolled > 0 ? Math.round((totalSubs / enrolled) * 100) : 0;
                return (
                    <div style={{ minWidth: 120 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                            <Link to={`/dashboard/assessments/${record.id}`}>
                                <span style={{ fontWeight: 700, color: '#0f172a', fontSize: 13 }}>
                                    {totalSubs}{' '}
                                    <span style={{ color: '#64748b', fontWeight: 500, fontSize: 12 }}>
                                        / {enrolled} Enrolled
                                    </span>
                                </span>
                            </Link>
                            <Tag color={pct >= 100 ? 'success' : pct > 0 ? 'processing' : 'default'} style={{ margin: 0, fontSize: 11, padding: '0 5px', borderRadius: 8 }}>
                                {pct}%
                            </Tag>
                        </div>
                        <Progress
                            percent={Math.min(pct, 100)}
                            showInfo={false}
                            size="small"
                            strokeColor={pct >= 80 ? '#16a34a' : pct >= 40 ? '#2563eb' : '#f59e0b'}
                            trailColor="#f1f5f9"
                            style={{ margin: 0 }}
                        />
                    </div>
                );
            }
        }
    ]

    // Admin Columns for Final Examination
    const adminFinalExamColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '14%',
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/dashboard/assessments/${record.id}`}>
                        <Button type="link" size="small" style={{ padding: 0, fontWeight: 600 }}>
                            View Task
                        </Button>
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Final Examination Component',
            dataIndex: 'title',
            key: 'title',
            width: '44%',
            ...getColumnSearchProps('title'),
            render: (title) => <span style={{ fontWeight: 600, color: '#0f172a' }}>{title}</span>
        },
        {
            title: 'Due Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '20%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
            render: (endDate) => {
                if (!endDate) return <span style={{ color: '#94a3b8' }}>N/A</span>
                const now = new Date()
                const end = new Date(endDate)
                const diff = end - now
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
                let color = '#334155'
                if (diffDays <= 7 && diffDays >= 0) {
                    color = '#2563eb'
                } else if (diffDays < 0) {
                    color = '#dc2626'
                }
                return (
                    <span style={{ color: color, fontWeight: diffDays < 0 ? 500 : 400 }}>
                        {endDate}
                    </span>
                )
            }
        },
        {
            title: 'Submissions',
            dataIndex: 'totalSubmissions',
            key: 'totalSubmissions',
            width: '24%',
            sorter: (a, b) => (Number(a.totalSubmissions) || 0) - (Number(b.totalSubmissions) || 0),
            render: (val, record) => {
                const totalSubs = Number(record.totalSubmissions) || 0;
                const enrolled = Number(record.enrolledStudents) || 0;
                const pct = enrolled > 0 ? Math.round((totalSubs / enrolled) * 100) : 0;
                return (
                    <div style={{ minWidth: 120 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                            <Link to={`/dashboard/assessments/${record.id}`}>
                                <span style={{ fontWeight: 700, color: '#0f172a', fontSize: 13 }}>
                                    {totalSubs}{' '}
                                    <span style={{ color: '#64748b', fontWeight: 500, fontSize: 12 }}>
                                        / {enrolled} Enrolled
                                    </span>
                                </span>
                            </Link>
                            <Tag color={pct >= 100 ? 'success' : pct > 0 ? 'processing' : 'default'} style={{ margin: 0, fontSize: 11, padding: '0 5px', borderRadius: 8 }}>
                                {pct}%
                            </Tag>
                        </div>
                        <Progress
                            percent={Math.min(pct, 100)}
                            showInfo={false}
                            size="small"
                            strokeColor={pct >= 80 ? '#16a34a' : pct >= 40 ? '#2563eb' : '#f59e0b'}
                            trailColor="#f1f5f9"
                            style={{ margin: 0 }}
                        />
                    </div>
                );
            }
        }
    ]

    const hadleGetCources = async () => {
        setLoading(true)
        try {
            let coursesList = []
            if (userProfile?.role === 'student') {
                const [enrolledCourses, roleCourses] = await Promise.all([
                    userProfile?.id ? getUsersCourses(userProfile.id) : [],
                    getAllCoursesByRole(userProfile.role, userProfile.id)
                ])
                const combined = [...(Array.isArray(enrolledCourses) ? enrolledCourses : [])]
                if (Array.isArray(roleCourses)) {
                    roleCourses.forEach(rc => {
                        if (!combined.some(c => String(c.id) === String(rc.id))) {
                            combined.push(rc)
                        }
                    })
                }
                coursesList = combined
            } else {
                coursesList = await getAllCoursesByRole(userProfile.role, userProfile.id)
            }
            dispatch(setAllCources(coursesList))
        } catch (error) {
            console.error('hadleGetCources', error)
        }
        setLoading(false)
    }

    const applyCombinedFilter = (courseVal, searchVal, sourceAssessments = allAssessments) => {
        if (!sourceAssessments) {
            setAssessments([])
            return
        }

        let filtered = [...sourceAssessments]

        // 1. Filter by Course Select
        if (courseVal && courseVal !== 'all') {
            filtered = filtered.filter(a => String(a.courseId) === String(courseVal))
        }

        // 2. Filter by search query
        const query = (searchVal || '').trim().toLowerCase()
        if (query) {
            filtered = filtered.filter(a => {
                const titleMatch = (a?.name || '').toLowerCase().includes(query)
                const courseNameMatch = (a?.courseName || '').toLowerCase().includes(query)
                const courseCodeMatch = (a?.courseCode || '').toLowerCase().includes(query)
                return titleMatch || courseNameMatch || courseCodeMatch
            })
        }

        setAssessments(filtered)
    }

    const handleCourseFilterChange = (value) => {
        setSelectedCourseFilter(value)
        applyCombinedFilter(value, searchAssessmentQuery)
    }

    const handleAssessmentSearch = (value) => {
        setSearchAssessmentQuery(value)
        applyCombinedFilter(selectedCourseFilter, value)
    }

    const handleGetAssessments = async () => {
        setLoading(true)
        try {
            const response = await getAssestmentsByRole(userProfile.role, userProfile.id)
            if (!response || response?.length === 0) {
                dispatch(setAllAssessments([]))
                setAssessments([])
            } else {
                dispatch(setAllAssessments(response))
                applyCombinedFilter(selectedCourseFilter, searchAssessmentQuery, response)

                if (Array.isArray(response)) {
                    const missingCourseIds = [...new Set(
                        response
                            .filter(a => a.courseId && !a.courseName)
                            .map(a => String(a.courseId))
                    )]

                    if (missingCourseIds.length > 0) {
                        const fetched = await Promise.all(
                            missingCourseIds.map(cId => getCourseById(cId).catch(() => null))
                        )
                        const newMap = {}
                        fetched.forEach(c => {
                            if (c && c.id) {
                                newMap[String(c.id)] = c
                            }
                        })
                        if (Object.keys(newMap).length > 0) {
                            setExtraCourseMap(prev => ({ ...prev, ...newMap }))
                        }
                    }
                }
            }
        } catch (error) {
            console.error('handleGetAssessments', error)
        }

        setLoading(false)
    }

    const handleExportAssessmentsToExcel = async (courseId, courseName) => {
        try {
            setExportingCourseId(courseId)
            message.loading({ content: `Preparing assessment and certificate details for ${courseName || 'course'}...`, key: 'exportAssessmentsMsg' })

            const res = await exportCourseAssessmentsDetails(courseId)
            if (!res || !res.success || !Array.isArray(res.data) || res.data.length === 0) {
                message.warning({
                    content: res?.message || 'No enrolled student records found to export for this course.',
                    key: 'exportAssessmentsMsg',
                })
                return
            }

            const courseAssessments = Array.isArray(res.courseAssessments) ? res.courseAssessments : []
            const totalCAs = courseAssessments.filter(a => a.assessmentType !== 'FINAL_EXAM').length
            const totalFinals = courseAssessments.filter(a => a.assessmentType === 'FINAL_EXAM').length

            // Map into comprehensive columns including all individual assessment marks & grades
            const excelRows = res.data.map((item, index) => {
                const row = {
                    'No.': index + 1,
                    'Name to Appear on Certificate': item.nameToAppearOnCertificate || '—',
                    'Student Registration Number': item.studentRegistrationNumber || '—',
                    'Course Name': item.courseName || courseName || '—',
                }

                // 1. All Individual Course Assessments (CAs & Final Exam)
                let caCount = 1
                let finalCount = 1
                courseAssessments.forEach((ass) => {
                    const isFinal = ass.assessmentType === 'FINAL_EXAM'
                    const prefix = isFinal
                        ? (totalFinals > 1 ? `Final Exam ${finalCount++}` : 'Final Exam')
                        : (totalCAs > 1 ? `CA ${caCount++}` : 'CA')
                    const assName = ass.name || `Assessment`
                    const assData = item.individualAssessments?.[ass.id] || {}

                    row[`${prefix}: ${assName} - Marks`] = assData.marks || '—'
                    row[`${prefix}: ${assName} - Grade`] = assData.displayGrade || '—'
                })

                // 2. Continuous Assessments (CA) Average (if course has CAs)
                if (res.hasCA) {
                    row['CA Average Marks'] = item.caAverageMarks || '—'
                    row['CA Average Grade'] = item.caGrade || '—'
                }

                // 3. Final Examination Summary (if course has Final Exam)
                if (res.hasFinalExam) {
                    row['Final Exam Marks'] = item.finalExamMarks || '—'
                    row['Final Exam Grade'] = item.finalExamGrade || '—'
                }

                // 4. Overall Final Certificate Standing
                row['Certificate Marks'] = item.certificateMarks || '—'
                row['Grade'] = item.grade || '—'
                row['Classification'] = item.classification || '—'

                // 5. Student Profile & Certificate Delivery Logistics
                row['Certificate Number'] = item.certificateNumber || '—'
                row['Permanent Address'] = item.permanentAddress || '—'
                row['Certificate Delivery Address'] = item.certificateDeliveryAddress || '—'
                row['Nearest City / Town'] = item.nearestCityTown || '—'
                row['Contact Number'] = item.contactNumber || '—'
                row['WhatsApp Number'] = item.whatsappNumber || '—'
                row['Email Address'] = item.emailAddress || '—'
                row['Certificate Issue Date'] = item.certificateIssueDate || '—'
                row['Certificate Status'] = item.certificateStatus || '—'
                row['Courier Tracking Number'] = item.courierTrackingNumber || '—'

                return row
            })

            const xlsx = await import('xlsx')
            const FileSaver = await import('file-saver')

            const worksheet = xlsx.utils.json_to_sheet(excelRows)

            // Auto-size column widths
            const colWidths = Object.keys(excelRows[0] || {}).map((key) => {
                let maxLen = key.length
                excelRows.forEach((r) => {
                    const val = r[key] ? String(r[key]) : ''
                    if (val.length > maxLen) maxLen = val.length
                })
                return { wch: Math.min(Math.max(maxLen + 3, 14), 48) }
            })
            worksheet['!cols'] = colWidths

            // Grading Rubric Reference Sheet
            const rubricRows = [
                { 'Marks Range': '75% - 100%', 'Grade': 'A', 'Classification': 'Distinction', 'Performance Standard': 'Outstanding Mastery & High Distinction' },
                { 'Marks Range': '65% - 74%',  'Grade': 'B', 'Classification': 'Merit',       'Performance Standard': 'Commendable Mastery & Merit Pass' },
                { 'Marks Range': '55% - 64%',  'Grade': 'C', 'Classification': 'Credit Pass', 'Performance Standard': 'Good Competence & Credit Pass' },
                { 'Marks Range': '50% - 54%',  'Grade': 'S', 'Classification': 'Ordinary Pass','Performance Standard': 'Minimum Pass & Satisfactory Competence' },
                { 'Marks Range': '0% - 49%',   'Grade': 'F', 'Classification': 'Fail',         'Performance Standard': 'Unsatisfactory / Incomplete Assessment' },
            ]
            const rubricWorksheet = xlsx.utils.json_to_sheet(rubricRows)
            rubricWorksheet['!cols'] = [{ wch: 18 }, { wch: 10 }, { wch: 20 }, { wch: 45 }]

            const courseNameClean = (res.course?.name || courseName || 'Course')
                .replace(/[^a-zA-Z0-9_\- ]/g, '')
                .trim()
                .replace(/\s+/g, '_')

            const dateStr = dayjs().format('YYYY-MM-DD')
            const workbook = {
                Sheets: {
                    'Assessments & Delivery': worksheet,
                    'Grading Scale Rubric': rubricWorksheet,
                },
                SheetNames: ['Assessments & Delivery', 'Grading Scale Rubric'],
            }

            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
            const dataBlob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            })

            FileSaver.default.saveAs(dataBlob, `${courseNameClean}_Assessment_Details_${dateStr}.xlsx`)
            message.success({
                content: `Successfully exported ${excelRows.length} assessment records for ${res.course?.name || courseName || 'this course'}!`,
                key: 'exportAssessmentsMsg',
            })
        } catch (error) {
            console.error('handleExportAssessmentsToExcel error:', error)
            message.error({ content: 'Failed to export course assessment details. Please try again.', key: 'exportAssessmentsMsg' })
        } finally {
            setExportingCourseId(null)
        }
    }

    return (
        <div className='assessments'>
            <div className='assessments-header'>
                <div className='assessments-header-title'>
                    <h1>Assessments</h1>
                    <div className='header-filters'>
                        <span className='filter-select'>
                            <Select
                                className='select'
                                value={selectedCourseFilter}
                                onChange={handleCourseFilterChange}
                                showSearch
                                optionFilterProp="children"
                                placeholder="Filter by course..."
                            >
                                <Select.Option value='all'>All Courses</Select.Option>
                                {allCources && [...allCources]
                                    .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''))
                                    .map(course => {
                                        const isPub = course?.isPublished === 1 || course?.isPublished === true
                                        const isCompleted = (course?.status || 'ongoing').toLowerCase() === 'completed'
                                        const isAdmin = userProfile?.role === 'superadmin' || userProfile?.role === 'admin'
                                        const statusLabel = isCompleted ? 'Completed' : 'Ongoing'
                                        const pubLabel = isAdmin ? ` • ${isPub ? 'Published' : 'Not Published'}` : ''
                                        return (
                                            <Select.Option key={course.id} value={course.id}>
                                                {course?.name} ({statusLabel}{pubLabel})
                                            </Select.Option>
                                        )
                                    })}
                            </Select>
                        </span>
                        <Input.Search
                            className='filter-search'
                            placeholder="Search by course or task title..."
                            allowClear
                            value={searchAssessmentQuery}
                            onSearch={handleAssessmentSearch}
                            onChange={(e) => handleAssessmentSearch(e.target.value)}
                        />
                    </div>
                </div>

                <div className='header-controls' style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <Segmented
                        className='view-segmented'
                        value={viewMode}
                        onChange={setViewMode}
                        options={[
                            { label: 'Grouped by Course', value: 'grouped', icon: <AppstoreOutlined /> },
                            { label: 'Table View', value: 'table', icon: <BarsOutlined /> },
                        ]}
                    />

                    {['superadmin', 'admin', 'instructor'].includes(userProfile?.role) && (
                        <>
                            {selectedCourseFilter !== 'all' && (
                                <Button
                                    icon={<FileExcelOutlined style={{ color: '#16a34a' }} />}
                                    loading={exportingCourseId === selectedCourseFilter}
                                    onClick={() => {
                                        const selectedCourse = allCources?.find(c => String(c.id) === String(selectedCourseFilter)) || extraCourseMap[String(selectedCourseFilter)]
                                        handleExportAssessmentsToExcel(selectedCourseFilter, selectedCourse?.name)
                                    }}
                                    style={{
                                        borderRadius: 6,
                                        fontWeight: 500,
                                        borderColor: '#86efac',
                                        color: '#15803d',
                                        background: '#f0fdf4',
                                    }}
                                >
                                    Export Course Assessments
                                </Button>
                            )}
                            <Button
                                type='primary'
                                className='btn'
                                onClick={() => setOpenAddAssessment(true)}
                            >
                                <PlusOutlined />
                                Create Assessment
                            </Button>
                        </>
                    )}
                </div>
            </div>

            <div className='assessments-content'>
                <Spin spinning={loading} tip='Loading...'>
                    {viewMode === 'grouped' ? (
                        /* --- GROUPED BY COURSE VIEW --- */
                        <div className='course-groups-container'>
                            {courseGroups.length === 0 ? (
                                <Card style={{ borderRadius: 12, padding: 32, textAlign: 'center' }}>
                                    <Empty description="No assessments available for the selected course filter." />
                                </Card>
                            ) : (
                                courseGroups.map((group) => {
                                    const caAssessments = group.assessments.filter(a => a.assessmentType !== 'FINAL_EXAM')
                                    const finalExamAssessments = group.assessments.filter(a => a.assessmentType === 'FINAL_EXAM')

                                    const caTableData = caAssessments.map(a => ({
                                        id: a.id,
                                        key: a.id,
                                        title: a.name,
                                        assessmentType: 'CA',
                                        courseName: a.courseName || group.courseName,
                                        endDate: a.endDate,
                                        status: a.attempt?.id ? true : false,
                                        marks: a.attempt?.marks,
                                        totalSubmissions: Number(a.totalSubmissions) || 0,
                                        uniqueSubmissions: Number(a.uniqueSubmissions) || 0,
                                        enrolledStudents: Number(a.enrolledStudents) || 0,
                                        rawAssessment: a,
                                    }))

                                    const finalExamTableData = finalExamAssessments.map(a => ({
                                        id: a.id,
                                        key: a.id,
                                        title: a.name,
                                        assessmentType: 'FINAL_EXAM',
                                        courseName: a.courseName || group.courseName,
                                        endDate: a.endDate,
                                        status: a.attempt?.id ? true : false,
                                        marks: a.attempt?.marks,
                                        totalSubmissions: Number(a.totalSubmissions) || 0,
                                        uniqueSubmissions: Number(a.uniqueSubmissions) || 0,
                                        enrolledStudents: Number(a.enrolledStudents) || 0,
                                        isEligibleForFinalExam: group.breakdown.caEligibility.isEligible,
                                        caEligibilityStatus: group.breakdown.caEligibility.status,
                                        caEligibilityReason: group.breakdown.caEligibility.reason,
                                        rawAssessment: a,
                                    }))

                                    return (
                                        <Card
                                            key={group.courseId}
                                            className="course-group-card"
                                            bodyStyle={{ padding: 0 }}
                                        >
                                            {/* Course Card Header with Overall Standing */}
                                            <div className="course-group-header">
                                                <div className="course-info-wrap">
                                                    <div className="course-icon-box">
                                                        <BookOutlined style={{ fontSize: 22 }} />
                                                    </div>
                                                    <div className="course-title-box">
                                                        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#0284c7', marginBottom: 2 }}>
                                                            Course Name
                                                        </div>
                                                        <h2>
                                                            {group.courseName}
                                                        </h2>
                                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6, flexWrap: 'wrap' }}>
                                                            {group.courseCode && (
                                                                <Tag color="geekblue" style={{ fontWeight: 600 }}>
                                                                    {group.courseCode}
                                                                </Tag>
                                                            )}
                                                            <Tag color={group.courseStatus === 'completed' ? 'default' : 'cyan'}>
                                                                {group.courseStatus === 'completed' ? 'Completed' : 'Ongoing'}
                                                            </Tag>
                                                            <span style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>
                                                                {caAssessments.length} CA {caAssessments.length === 1 ? 'task' : 'tasks'} • {finalExamAssessments.length} Final Exam
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {isStudent ? (
                                                    <div className="course-header-standing" style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                                                        <div className="standing-status-wrap" style={{ textAlign: 'right' }}>
                                                            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', fontWeight: 600 }}>
                                                                Course Standing
                                                            </div>
                                                            {group.breakdown.isFullyCompleted ? (
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'flex-end', marginTop: 2 }}>
                                                                    <TrophyOutlined style={{ color: group.breakdown.overallColor, fontSize: 16 }} />
                                                                    <span style={{ fontSize: 15, fontWeight: 700, color: group.breakdown.overallColor }}>
                                                                        {group.breakdown.overallClassification} (Grade {group.breakdown.overallGrade})
                                                                    </span>
                                                                </div>
                                                            ) : group.performance.isGraded ? (
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'flex-end', marginTop: 2 }}>
                                                                    <TrophyOutlined style={{ color: group.performance.color, fontSize: 16 }} />
                                                                    <span style={{ fontSize: 14, fontWeight: 700, color: group.performance.color }}>
                                                                        {group.performance.classification} (Grade {group.performance.grade})
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <Tag color="default" style={{ marginTop: 2 }}>
                                                                    Pending Evaluation
                                                                </Tag>
                                                            )}
                                                        </div>

                                                        <Button
                                                            type="primary"
                                                            className="academic-transcript-btn"
                                                            size="middle"
                                                            icon={<FileTextOutlined style={{ color: '#ffffff' }} />}
                                                            onClick={() => {
                                                                setSelectedTranscriptGroup(group)
                                                                setIsTranscriptOpen(true)
                                                            }}
                                                            style={{
                                                                background: '#0284c7',
                                                                borderColor: '#0284c7',
                                                                color: '#ffffff',
                                                                borderRadius: 6,
                                                                fontWeight: 600,
                                                                boxShadow: '0 2px 4px rgba(2, 132, 199, 0.25)',
                                                            }}
                                                        >
                                                            Academic Transcript
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <div className="course-header-action" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                        <Button
                                                            size="middle"
                                                            icon={<FileExcelOutlined style={{ color: '#16a34a' }} />}
                                                            loading={exportingCourseId === group.courseId}
                                                            onClick={() => handleExportAssessmentsToExcel(group.courseId, group.courseName)}
                                                            style={{
                                                                borderRadius: 6,
                                                                fontWeight: 500,
                                                                borderColor: '#86efac',
                                                                color: '#15803d',
                                                                background: '#f0fdf4',
                                                            }}
                                                        >
                                                            Export Assessment Details
                                                        </Button>
                                                        <Link to={`/dashboard/cources/${group.courseId}`}>
                                                            <Button size="middle" style={{ borderRadius: 6 }}>
                                                                View Course
                                                            </Button>
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>

                                            {/* SECTION 1: CONTINUOUS ASSESSMENTS (CA) TABLE (With Marks for Students) */}
                                            <div className="assessment-sub-section">
                                                <div className="sub-section-header">
                                                    <div className="sub-section-title-wrap" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                        <span style={{ fontSize: 15, fontWeight: 700, color: '#1e293b' }}>
                                                            Part 1: Continuous Assessments (CA)
                                                        </span>
                                                        <Tag color="blue" style={{ fontWeight: 600, borderRadius: 4 }}>
                                                            Weightage: 50%
                                                        </Tag>
                                                        <span style={{ fontSize: 13, color: '#64748b' }}>
                                                            ({caAssessments.length} {caAssessments.length === 1 ? 'task' : 'tasks'})
                                                        </span>
                                                    </div>

                                                    {isStudent && (
                                                        <div className="sub-section-tag-wrap" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                            {group.breakdown.hasCA && (
                                                                <Tooltip title={group.breakdown.caEligibility.reason}>
                                                                    <Space size={6} wrap>
                                                                        <Tag color="blue" style={{ fontWeight: 600, margin: 0 }}>
                                                                            CA Avg: {group.breakdown.caEligibility.caAverage !== null ? `${group.breakdown.caEligibility.caAverage}%` : 'Pending'}
                                                                        </Tag>
                                                                        <Tag
                                                                            color={group.breakdown.caEligibility.tagColor}
                                                                            style={{ fontWeight: 600, margin: 0, cursor: 'pointer' }}
                                                                        >
                                                                            {group.breakdown.caEligibility.status === 'ELIGIBLE' && <CheckCircleOutlined style={{ marginRight: 4 }} />}
                                                                            {group.breakdown.caEligibility.status === 'NOT_ELIGIBLE' && <CloseCircleOutlined style={{ marginRight: 4 }} />}
                                                                            {group.breakdown.caEligibility.status === 'PENDING' && <ClockCircleOutlined style={{ marginRight: 4 }} />}
                                                                            {group.breakdown.caEligibility.label}
                                                                        </Tag>
                                                                    </Space>
                                                                </Tooltip>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                                {caAssessments.length === 0 ? (
                                                    <div style={{ padding: '20px 24px', color: '#94a3b8', fontSize: 13, textAlign: 'center' }}>
                                                        No Continuous Assessment tasks assigned for this course.
                                                    </div>
                                                ) : (
                                                    <>
                                                        {!isMobile && (
                                                            <div className="assessment-desktop-table">
                                                                <Table
                                                                    columns={isStudent ? studentCAColumns : adminCAColumns}
                                                                    dataSource={caTableData}
                                                                    pagination={false}
                                                                    size="middle"
                                                                    scroll={{ x: isStudent ? 850 : 700 }}
                                                                />
                                                            </div>
                                                        )}
                                                        {isMobile && (
                                                            <div className="assessment-mobile-cards">
                                                                {caTableData.map(item => renderMobileAssessmentCard(item, 'CA'))}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                            {/* SECTION 2: FINAL EXAMINATION TABLE (No numeric marks for Students) */}
                                            <div className="assessment-sub-section" style={{ borderTop: '1px solid #e2e8f0' }}>
                                                <div className="sub-section-header">
                                                    <div className="sub-section-title-wrap" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                        <span style={{ fontSize: 15, fontWeight: 700, color: '#1e293b' }}>
                                                            Part 2: Final Examination
                                                        </span>
                                                        <Tag color="purple" style={{ fontWeight: 600, borderRadius: 4 }}>
                                                            Weightage: 50%
                                                        </Tag>
                                                        <span style={{ fontSize: 13, color: '#64748b' }}>
                                                            ({finalExamAssessments.length} {finalExamAssessments.length === 1 ? 'task' : 'tasks'})
                                                        </span>
                                                    </div>

                                                    {isStudent && (
                                                        <div className="sub-section-tag-wrap" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                            {group.breakdown?.finalExamPerformance?.isGraded ? (
                                                                <Tag color={group.breakdown.finalExamPerformance.tagColor} style={{ fontWeight: 600, padding: '3px 10px', borderRadius: 6 }}>
                                                                    Awarded: Grade {group.breakdown.finalExamPerformance.grade} • {group.breakdown.finalExamPerformance.classification}
                                                                </Tag>
                                                            ) : !group.breakdown?.caEligibility?.isEligible ? (
                                                                <Tag color="error" style={{ fontWeight: 600, padding: '3px 10px', borderRadius: 6 }}>
                                                                    <LockOutlined style={{ marginRight: 4 }} /> Final Exam Locked: Requires CA Average ≥ 50%
                                                                </Tag>
                                                            ) : (
                                                                <Tag color="cyan" style={{ fontWeight: 600, padding: '3px 10px', borderRadius: 6 }}>
                                                                    <CheckCircleOutlined style={{ marginRight: 4 }} /> Eligible to Attempt Final Exam
                                                                </Tag>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                                {finalExamAssessments.length === 0 ? (
                                                    <div style={{ padding: '20px 24px', color: '#94a3b8', fontSize: 13, textAlign: 'center' }}>
                                                        No Final Examination published for this course yet.
                                                    </div>
                                                ) : (
                                                    <>
                                                        {!isMobile && (
                                                            <div className="assessment-desktop-table">
                                                                <Table
                                                                    columns={isStudent ? studentFinalExamColumns : adminFinalExamColumns}
                                                                    dataSource={finalExamTableData}
                                                                    pagination={false}
                                                                    size="middle"
                                                                    scroll={{ x: isStudent ? 850 : 700 }}
                                                                />
                                                            </div>
                                                        )}
                                                        {isMobile && (
                                                            <div className="assessment-mobile-cards">
                                                                {finalExamTableData.map(item => renderMobileAssessmentCard(item, 'FINAL_EXAM'))}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                            {/* Summary Calculation Footer (Students Only) */}
                                            {isStudent && (
                                                <div className="course-group-footer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <TrophyOutlined style={{ color: group.breakdown.overallColor || '#0284c7', fontSize: 16 }} />
                                                        <span style={{ fontSize: 13, color: '#334155', fontWeight: 500 }}>
                                                            {group.breakdown.summaryText}
                                                        </span>
                                                    </div>
                                                    <Button
                                                        type="link"
                                                        size="small"
                                                        icon={<FileTextOutlined style={{ color: '#0284c7' }} />}
                                                        onClick={() => {
                                                            setSelectedTranscriptGroup(group)
                                                            setIsTranscriptOpen(true)
                                                        }}
                                                        style={{ fontWeight: 600, color: '#0284c7', padding: 0 }}
                                                    >
                                                        View Full Academic Transcript & Grading Report →
                                                    </Button>
                                                </div>
                                            )}
                                        </Card>
                                    )
                                })
                            )}
                        </div>
                    ) : (
                        /* --- FLAT TABLE VIEW --- */
                        <div className='assessments-list'>
                            {!isMobile && (
                                <div className="assessment-desktop-table">
                                    <Table
                                        columns={['superadmin', 'admin', 'instructor'].includes(userProfile?.role) ? adminColumns : studentFlatColumns}
                                        dataSource={tableData}
                                        pagination={{
                                            pageSize: 50,
                                            position: ["bottomRight"],
                                        }}
                                        scroll={{ x: 1000 }}
                                    />
                                </div>
                            )}
                            {isMobile && (
                                <div className="assessment-mobile-cards">
                                    {tableData.length === 0 ? (
                                        <Card style={{ borderRadius: 10, textAlign: 'center', padding: 24 }}>
                                            <Empty description="No assessments found." />
                                        </Card>
                                    ) : (
                                        tableData.map(item => renderMobileAssessmentCard(item, 'FLAT'))
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </Spin>
            </div>

            <AddAssessment
                isOpen={openAddAssessment}
                setOpen={setOpenAddAssessment}
                cources={allCources}
                handleGetAssessments={handleGetAssessments}
                loading={loading}
            />

            <AcademicTranscriptModal
                isOpen={isTranscriptOpen}
                onClose={() => {
                    setIsTranscriptOpen(false)
                    setSelectedTranscriptGroup(null)
                }}
                courseGroup={selectedTranscriptGroup}
                userProfile={userProfile}
            />
        </div>
    )
}

export default Assessments